var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 38,
    viewBox: "0 0 34 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4061 21.1147C32.5644 24.4722 28.5873 26.8447 20.6325 31.59C12.9428 36.1769 9.098 38.4707 5.99951 37.5487C4.71848 37.1674 3.55132 36.4437 2.61001 35.4464C0.333252 33.0344 0.333252 28.3562 0.333252 18.9997C0.333252 9.64324 0.333252 4.965 2.61001 2.55305C3.55132 1.55588 4.71848 0.831955 5.99951 0.450806C9.098 -0.471117 12.9428 1.82243 20.6325 6.40957C28.5873 11.1547 32.5644 13.5272 33.4061 16.8847C33.7534 18.2707 33.7534 19.7287 33.4061 21.1147Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.c18744b3e6f5bdea5f9099a17541b2a5.svg";
export { ForwardRef as ReactComponent };